import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const pains = [
  { num: '01', text: 'Missing BPM and key data across your library' },
  { num: '02', text: 'Inconsistent ID3 tags from mixed import sources' },
  { num: '03', text: 'Hours of manual metadata fixing before every gig' },
  { num: '04', text: 'Rekordbox import/export losing cue points and tags' },
];

export default function Problem() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="problem" data-testid="problem-section" ref={ref} className="section">
      <div className="container">
        <div className="split-grid prob-grid">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={v ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8 }}>
            <span className="eyebrow">The Problem</span>
            <h2 data-testid="problem-title" className="section-title">
              Your library is broken.<br /><span className="section-title-muted">Bonk fixes it.</span>
            </h2>
            <p className="text-body text-body--narrow" style={{ marginTop: 20 }}>
              Every DJ knows the pain of messy metadata. You spend more time fixing tags than actually mixing. It doesn&apos;t have to be this way.
            </p>
          </motion.div>

          <div className="pain-list">
            {pains.map((p, i) => (
              <motion.div
                key={p.num}
                data-testid={`pain-point-${i}`}
                className="pain-item"
                initial={{ opacity: 0, x: 20 }}
                animate={v ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.2 + i * 0.08 }}
              >
                <span className="pain-num">{p.num}</span>
                <span className="pain-text">{p.text}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
